module.exports = __webpack_public_path__ + "static/media/x.c3e18467.svg";